import React from 'react';

export const StepSeparatorPlus: React.FC = () => {
  return (
    <div className="flex items-center justify-center w-8 h-8 flex-shrink-0">
      <div className="w-6 h-6 flex items-center justify-center text-gray-400 text-xl font-light">+</div>
    </div>
  );
};
